// removed by extract-text-webpack-plugin
module.exports = {"btnLink":"btnLink__-OgBW"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CollapseToggle/styles.scss
// module id = 2122
// module chunks = 1